const states = {
  page_details: {
    is_internet_connected: navigator.onLine,
    checking_internet: false,
    lang: 'en',
    device_data: {},
    page_title: "",
    current_page: "",
    current_sider_module: "",
    agent_states: [],
    roles: [],
    loaders: {
      page_loading: false,
      page_loading_text: "",
      bot_training: false,
      bot_publishing: false,
      wa_file_uploading: false
    }
  },
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/page_details/states.js